import { FieldHasValue } from 'helpers/Validation';

export const AsLeftResultFormulaP732 = (formData) => {
    if (FieldHasValue(formData.F594AltForcedTripSignal) && FieldHasValue(formData.F595AltConfirmRelayOperatesCorrectly)) {
        if (formData.F594AltForcedTripSignal === 'YES' && formData.F595AltConfirmRelayOperatesCorrectly === 'YES') {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
